import animations from './animations';
import * as borders from './borders';
import * as colors from './colors';
import { breakpoints, mediaQueries } from './responsive';
import shadows from './shadows';
import space from './space';
import transitions from './transitions';
import * as typography from './typography';

const theme = {
  animations,
  border: {
    ...borders,
  },
  breakpoints,
  colors,
  shadows,
  space,
  mediaQueries,
  transitions,
  typography,
};

export default theme;
